import React, { useState } from 'react';
import '../../style.css';
import T from 'i18n-react';
import { Typography, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const PriceTierAccordion = ({ PricingDetails }) => {
    const [expandedAccordion, setExpandedAccordion] = useState(false);
    const handleAccordionChange = () => {
        setExpandedAccordion(!expandedAccordion);
    };

    return (
        <div className="price-tier-accordion-wrapper price-right-margin price-right-left">
            <a className="accordion" onClick={handleAccordionChange}>
                <div className="accordion-summary">
                    <Typography className="summary-text">
                        {expandedAccordion ?
                            <ExpandLessIcon className="arrow-icon" /> :
                            <ExpandMoreIcon className="arrow-icon" />
                        }
                        <IconButton edge="start" color="inherit" aria-label="menu">
                        </IconButton>
                        {expandedAccordion ? <T.span className="price-accordian-span" text='Interview.Page10a.HideDetails' /> : <T.span className="price-accordian-span" text='Interview.Page10a.SeeDetails' />}
                    </Typography>
                </div>
                {expandedAccordion && (
                    <div className="accordion-details">
                        <div>
                            <ul>
                                {PricingDetails.map((item, index) => (
                                    <li className='list-item'><T.span key={index} className='list-item-text' text={item} /></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
            </a>
        </div>
    )
}

export default PriceTierAccordion;